import { Credentials } from '../../types/Login';
import {
  isPoisonedCredential,
  purgePoisonedStoredCredential,
  USER_STORAGE_USER_KEY,
} from '../../utils/credentialGuard';

export { USER_STORAGE_USER_KEY };

export const storeUser = (userObject: Credentials) => {
  return new Promise((resolve: any, reject) => {
    if (!userObject) {
      reject(new Error('Cannot store empty user'));
      return;
    }
    // Resolve without persisting: rejecting here would bubble out of the
    // login sagas (their `yield call(storeUser, ...)` is uncaught) and cancel
    // the whole rootSaga. Dropping the poisoned credential is the fix itself.
    if (isPoisonedCredential(userObject.access_token?.value)) {
      purgePoisonedStoredCredential('storeUser');
      resolve();
      return;
    }
    window.localStorage.setItem(
      USER_STORAGE_USER_KEY,
      JSON.stringify(userObject.access_token),
    );

    resolve();
  });
};

export const getUser = () => {
  const purged = purgePoisonedStoredCredential('getUser');
  const token = purged
    ? null
    : window.localStorage.getItem(USER_STORAGE_USER_KEY);

  return new Promise((resolve, reject) => {
    if (!!token && token.length) {
      resolve(JSON.parse(token));
      return;
    }
    reject(new Error('No user found'));
  });
};
